import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fmtMoney = (n) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: 0,
  }).format(Number(n) || 0);

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return d;
  }
};

export const fmtDateTime = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  } catch {
    return d;
  }
};

export const STAGES = [
  "Webinar / Introduction",
  "Commercial Proposal",
  "Proof of Concept",
  "Commercial Approval",
  "Awaiting PO",
  "Closed Won",
  "Closed Lost",
];

export const STAGE_PROBABILITY = {
  "Webinar / Introduction": 10,
  "Commercial Proposal": 20,
  "Proof of Concept": 50,
  "Commercial Approval": 75,
  "Awaiting PO": 90,
  "Closed Won": 100,
  "Closed Lost": 0,
};

export const SUB_TYPES = [
  "New Business",
  "Renewal",
  "Upsell",
  "Cross-sell",
  "Downgrade",
  "One-off",
  "Services",
];

export const CLOSED_LOST_REASONS = [
  "Staying with Incumbent",
  "Technical Challenge",
  "Budget",
  "Non Attendance",
];

export const TICKET_STATUSES = [
  "New",
  "Open",
  "Waiting on Customer",
  "Waiting on Internal",
  "Resolved",
  "Closed",
];

export const PRIORITIES = ["Low", "Medium", "High", "Urgent"];
